import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Day, WeekRow } from 'components/Dealer/DealerContact/HoursInfo';
import Icon from 'components/Shared/Icon';
import clockIcon from 'public/static/images/dealer_pages/clock.svg';
import styles from './styles';

const Hours = ({ hours }) => {
  const { t } = useTranslation();
  const [isFullHoursOpen, setIsFullHoursOpen] = useState();

  return (
    <div className="hours">
      <header className="header">
        <Icon image={clockIcon} />
        <div className="today">
          <div className="title" data-testid="today-status">
            {hours.isOpenToday
              ? t('dealerPages.openToday')
              : t('dealerPages.closedToday')}
          </div>
          <div className="flex">
            {hours.isOpenToday && (
              <Day hours={hours.hoursToday} isOpen={true} />
            )}
          </div>
        </div>
      </header>
      <div className="full-hours-container">
        <button
          className={`toggle-hours show-hours ${
            isFullHoursOpen ? 'hidden' : ''
          }`}
          data-testid="show-hours"
          onClick={() => {
            setIsFullHoursOpen(true);
          }}
        >
          {t('dealerPages.showAllHours')}
        </button>
        <table
          data-testid="full-hours"
          className={`full-hours ${isFullHoursOpen ? 'open' : ''}`}
        >
          <tbody>
            {hours.hoursByDay.map((dayHours) => {
              const { day, hours: hoursForDay, isOpen, isToday } = dayHours;

              return (
                <WeekRow
                  hours={hoursForDay}
                  isOpen={isOpen}
                  isToday={isToday}
                  day={day}
                  key={day}
                />
              );
            })}
          </tbody>
        </table>
        <button
          className={`toggle-hours hide-hours ${isFullHoursOpen || 'hidden'}`}
          data-testid="hide-hours"
          onClick={() => {
            setIsFullHoursOpen(false);
          }}
        >
          {t('dealerPages.hideAllHours')}
        </button>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

Hours.propTypes = {
  hours: PropTypes.object,
};

export default Hours;
